import { MdKeyboardArrowRight } from "react-icons/md"
import { Header } from "../../components/NavBar"
import { Outlet, useNavigate } from "react-router-dom"
import { NavigationLink } from "./setup"
import { settingsLinks } from "../../entries"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { BreadCrumbsGeneral } from "../../components/NavigationComponents"
import { AccountContext } from "../../contexts/AccountContexts"


export const SettingsMain = () => {
    const { t } = useTranslation('settings')
    return (
        <div className="flex flex-col justify-start items-center w-full py-2 gap-5 pb-10 px-4 h-full">
            <div className="w-full">
                <h1 className="text-xl font-semibold">{t('Settings')}</h1>
                <SidebarLayout links={settingsLinks} />
            </div>
        </div>
    )
}


const SidebarLayout = ({ links }) => {
    const { t } = useTranslation('settings')
    const { language } = useContext(AccountContext)
    const navigator = useNavigate()
    const [breadCrumbs, setBreadCrumbs] = useState(
        [
            {
                link: "/admin/dashboard",
                name: t("Home")
            },
            {
                link: "/admin/settings/profile-settings",
                name: t("Settings")
            },
            {
                link: null,
                name: t('Profile')
            }
        ]
    )
    useEffect(() => {
        if (window.location.pathname == "/admin/settings") {
            navigator("/admin/settings/profile-settings")
        }
    }, [])

    useEffect(() => {
        setBreadCrumbs(prev =>
            [
                {
                    link: "/admin/dashboard",
                    name: t("Home")
                },
                {
                    link: "/admin/settings/profile-settings",
                    name: t("Settings")
                },
                {
                    link: null,
                    name: t(settingsLinks.find((element) => element.link === window.location.pathname.split("/").pop()).title)
                }
            ]
        )
    }, [t])


    const getTitle = (title) => {
        setBreadCrumbs((prev) => {
            prev.pop()
            return [...prev, {
                link: null,
                name: title
            }]
        })
    }

    return (
        <>
            <BreadCrumbsGeneral elements={breadCrumbs} />
            <div className="flex flex-col lg:flex-row w-full py-3 gap-3">
                {/* Options Navigation */}
                <div className="w-full lg:w-80 grid grid-cols-2 sm:grid-cols-4 gap-2 lg:gap-0 lg:flex lg:flex-col lg:join join-vertical shadow-md h-fit">
                    {
                        links.map((link, index) =>
                            <NavigationLink key={index} props={link} getTitle={getTitle} />
                        )
                    }
                </div>
                {/* Options View Page */}
                <div className="flex  flex-col w-full px-2 h-full">
                    <Outlet />
                </div>
            </div>
        </>
    )
}